import AddressFormComponent, {
  AddressFormViewProps,
  AddressFormComponentProps,
} from './AddressFormComponent';

export default AddressFormComponent;

export type { AddressFormComponentProps, AddressFormViewProps };
